<template>
  <div>
    <EncodeHeader urlEncode/>
    <v-container>
      <v-row>
        <v-col cols="8">
          <v-textarea
            outlined
            name="input-10-6"
            label="URL"
            rows='8'
            v-model="decoded"
          ></v-textarea>
          <v-btn block color="primary" dark @click="handleEncode()">Encode</v-btn>
          <br/>
          <v-textarea
            outlined
            name="input-10-6"
            label="Encoded URL"
            rows='8'
            v-model="encoded"
          ></v-textarea>
        </v-col>
        <v-col cols="4">
        <p>Did you know?</p>
         <ul>
            <li>URL stands for Uniform Resource Locator.</li>
            <li>URL encode also refers to percent-encoding.</li>
            <li>URL use some characters for special use in defining their syntax. When these characters are not used in their special role inside a URL, they need to be encoded.</li>
            <li>The unreserved characters should not be encoded. The unreserved characters are: A B C D E F G H I J K L M N O P Q R S T U V W X Y Z a b c d e f g h i j k l m n o p q r s t u v w x y z 0 1 2 3 4 5 6 7 8 9 - _ . ~</li>
            <li>The reserved characters have to be encoded only under certain circumstances. The reserved characters are:! * ' ( ) ; : @ & = + $ , / ? % # [ ]</li>
            <li>URL encode replace non-ASCII characters and - _ . ~ should be encoded as % plus a two-digit hexadecimal. ex:- encodify@1234 ==> encodify%401234</li>
            <li>URLs cannot contain spaces. URL encoding normally replaces a space with a plus (+) sign, or %20.</li>
          </ul>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    EncodeHeader: () => import('./EncodeHeader.vue')
  },
  data() {
    return {
      encoded: "",
      decoded: "",
      name: "URL Encode"
    };
  },
  created () {
      document.title = "Online URL Encode - Encodify";
  },
  methods: {
    handleEncode() {
      this.encoded = encodeURIComponent(this.decoded);
    }
  }
};
</script>
